import React, {FC, ReactElement, ReactNode} from "react";
import {FormControl, FormControlLabel, FormLabel, Radio, RadioGroup} from "@mui/material";
import {useTranslation} from "react-i18next";

interface IProps {
    required?: boolean
    label: ReactNode,
    value?: boolean | null,
    onChange: (newValue: boolean) => void
}

export const YesNoRadioGroup: FC<IProps> = ({required = false, label, value, onChange}): ReactElement => {
    const {t} = useTranslation()

    return <FormControl>
        <FormLabel required={required}>{label}</FormLabel>
        <RadioGroup row value={value}
                    onChange={e => {
                        onChange(e.target.value === "true");
                    }}>
            <FormControlLabel value={true} control={<Radio/>} label={t("common.yes", "Yes")}/>
            <FormControlLabel value={false} control={<Radio/>} label={t("common.no", "No")}/>
        </RadioGroup>
    </FormControl>
}


export default YesNoRadioGroup;

